import React from 'react';

import { Chip, Stack, Tooltip, Typography } from '@mui/material';

import { useGetPromoWarnings } from '~/hooks/apis/promo/useGetPromoWarnings';

import { GetPromoWarningsQuery } from '~/services/PromoService';

type Props = { codeName: string; brand: GetPromoWarningsQuery['brand'] };

export default function PromoDisplayConfigWarningsCell({ codeName, brand }: Props) {
  const { data, isLoading, error } = useGetPromoWarnings({ codeName, brand });

  if (!brand) {
    return <Typography variant="body2">Warnings unavailable for this brand.</Typography>;
  }
  if (!codeName) {
    return null;
  }
  if (isLoading) {
    return <Typography variant="body2">Loading warnings…</Typography>;
  }
  if (error) {
    return (
      <Tooltip title={error.message}>
        <Typography variant="body2" color="error">
          Could not load warnings.
        </Typography>
      </Tooltip>
    );
  }

  const warnings = (data ?? []).filter((warning) => !warning.is_dev);
  return (
    <Stack spacing={1} sx={{ py: 1, alignItems: 'flex-start', maxHeight: '100%', overflow: 'auto' }}>
      {warnings.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No warnings
        </Typography>
      )}
      {warnings.map((warning, index) => (
        <Tooltip key={`${warning.code}-${index}`} title={warning.message}>
          <Chip size="small" label={warning.code} color={warning.level} />
        </Tooltip>
      ))}
    </Stack>
  );
}
